import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../../styles/addReceipt.module.css";
import { InvoiceCxc } from "./InvoiceCxc";
import { CxcSummary } from "./CxcSummary";
import { formatCurrency } from "../../../../../shared/utils/formatCurrency";

const PAGE_SIZE = 10;

export function CxcDetails({
  setFacturasData,
  facturasData,
  updateAbono,
  updateChecked,
  toggleDiferencial,
  restante,
  count,
  onDistribute,
  receiptMonto,
  bancoMoneda = "CRC",
  TC_compra   = 1,
}) {
  return (
    <div className={styles["cxc-details"]}>
      <CxcDetailsHeader />
      <CxcDetailsBody
        setFacturasData={setFacturasData}
        facturasData={facturasData}
        count={count}
        updateAbono={updateAbono}
        updateChecked={updateChecked}
        toggleDiferencial={toggleDiferencial}
        onDistribute={onDistribute}
        receiptMonto={receiptMonto}
        restante={restante}
        bancoMoneda={bancoMoneda}
        TC_compra={TC_compra}
      >
        <CxcSummary
          facturasData={facturasData}
          restante={restante}
          bancoMoneda={bancoMoneda}
          TC_compra={TC_compra}
        />
      </CxcDetailsBody>
    </div>
  );
}

function CxcDetailsHeader() {
  const { t } = useTranslation();
  return (
    <div className={styles["cxc-details-header"]}>
      <h1>
        <i className={`fa-solid fa-folder ${styles["icon-cxc-details"]}`} />{" "}
        {t("recibos.registroCxC")}
      </h1>
    </div>
  );
}

function CxcDetailsBody({
  setFacturasData,
  facturasData,
  count,
  updateAbono,
  updateChecked,
  toggleDiferencial,
  onDistribute,
  receiptMonto,
  restante,
  bancoMoneda = "CRC",
  TC_compra   = 1,
  children,
}) {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(facturasData.length / PAGE_SIZE);

  const visibles = facturasData.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  function handleSelectAll(checked) {
    if (checked) {
      onDistribute();
    } else {
      setFacturasData((prev) =>
        prev.map((inv) => ({ ...inv, abono: 0, favor: 0, checked: false })),
      );
    }
    setPage(1);
  }

  const someChecked = Boolean(facturasData.find((inv) => inv.checked));

  return (
    <div className={styles["receipt-details-body"]}>
      <div className={styles["table-responsive"]}>
        <div className={styles["invoice-table"]}>
          <table>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={someChecked}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                  />
                </th>
                <th>{t("recibos.colFactura")}</th>
                <th>{t("recibos.colRubro")}</th>
                <th>{t("common.saldo")}</th>
                <th style={{ paddingRight: "20px" }}>{t("cxp.abono")}</th>
                <th style={{ paddingLeft: 6 }}></th>
              </tr>
            </thead>
            <tbody>
              {visibles.map((inv) => (
                <InvoiceCxc
                  key={inv.id}
                  inv={inv}
                  updateAbono={updateAbono}
                  updateChecked={updateChecked}
                  toggleDiferencial={toggleDiferencial}
                  remainingCRC={restante}
                  TC_compra={TC_compra}
                  bancoMoneda={bancoMoneda}
                />
              ))}
            </tbody>
          </table>

          <div
            className={styles["footer-info"]}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 14px",
              minWidth: 720,
            }}
          >
            <span>{facturasData.length} {t("recibos.cxcActivas")}</span>

            {totalPages > 1 && (
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <button
                  disabled={page === 1}
                  onClick={() => setPage((p) => p - 1)}
                  style={{
                    padding: "3px 10px",
                    fontSize: 12,
                    background: page === 1 ? "var(--hover-bg)" : "var(--hover-bg-strong)",
                    color: page === 1 ? "var(--text-muted)" : "var(--text-secondary)",
                    border: "1px solid var(--border-card)",
                    borderRadius: 4,
                    cursor: page === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  {t("common.anteriorCorto")}
                </button>
                <span style={{ fontSize: 12, color: "var(--text-secondary)" }}>
                  {page} / {totalPages}
                </span>
                <button
                  disabled={page === totalPages}
                  onClick={() => setPage((p) => p + 1)}
                  style={{
                    padding: "3px 10px",
                    fontSize: 12,
                    background: page === totalPages ? "var(--hover-bg)" : "var(--hover-bg-strong)",
                    color: page === totalPages ? "var(--text-muted)" : "var(--text-secondary)",
                    border: "1px solid var(--border-card)",
                    borderRadius: 4,
                    cursor: page === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  {t("common.siguienteCorto")}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}
